import Modal from '~/components/common/modal';
import { Translate } from '~/i18n';
import { Button } from '~/components/common/button';
import { CheckedCircleIcon } from '~/svgs';
import { SubmitLoader } from '../common/loaders/submit';

interface ApplicationSendSuccessModalProps {
   open: boolean;
   closeModal: () => any;
   sendApplication: any;
   applicants: string | number;
   isSuccess: boolean;
   loading: boolean;
}

const ApplicationSendSuccessModal = ({
   open,
   closeModal,
   applicants,
   sendApplication,
   isSuccess,
   loading,
}: ApplicationSendSuccessModalProps) => {
   return (
      <Modal size="sm" open={open} onClickOutside={closeModal}>
         <Modal.Body className="flex justify-center p-10">
            <div className="flex flex-col items-center">
               {isSuccess ? (
                  <>
                     <CheckedCircleIcon />
                     <div className="mt-4 text-3xl font-black text-center">
                        {applicants} <Translate id="visasManager:applicants sent for review" />
                     </div>

                     <div className="mt-5 text-base font-medium text-center">
                        <Translate id="visasManager:keep track of the applicants" />
                     </div>

                     <div className="w-full mt-12 text-center ">
                        <Button
                           type="button"
                           onClick={closeModal}
                           theme="primary"
                           className="!w-full">
                           <Translate id="common:done" />
                        </Button>
                     </div>
                  </>
               ) : (
                  <div className="flex flex-col text-center">
                     <div className="mt-4 text-3xl font-black text-center">
                        <Translate id="visasManager:send visa applications for review" />
                     </div>
                     <div className="mt-5 text-base font-medium text-center">
                        <Translate id="visasManager:confirm sending applicants" />
                     </div>
                     <div className="flex justify-center mt-12 space-x-2 rtl:space-x-reverse">
                        <Button
                           onClick={() => {
                              closeModal();
                           }}
                           theme="secondary"
                           className="h-12 text-white w-28">
                           <Translate id="common:close" />
                        </Button>
                        <Button
                           onClick={() => {
                              sendApplication();
                           }}
                           theme="primary"
                           className="h-12 text-white w-28 submit-product">
                           {loading ? <SubmitLoader /> : <Translate id="common:submit" />}
                        </Button>
                     </div>
                  </div>
               )}
            </div>
         </Modal.Body>
      </Modal>
   );
};

export default ApplicationSendSuccessModal;
